/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Property contact numbe
 * @export
 * @interface TravelinePhoneDto
 */
export interface TravelinePhoneDto {
    /**
     * Phone number
     * @type {string}
     * @memberof TravelinePhoneDto
     */
    phoneNumber?: string | null;
    /**
     * Comments to the phone number
     * @type {string}
     * @memberof TravelinePhoneDto
     */
    remark?: string | null;
}

/**
 * Check if a given object implements the TravelinePhoneDto interface.
 */
export function instanceOfTravelinePhoneDto(value: object): value is TravelinePhoneDto {
    return true;
}

export function TravelinePhoneDtoFromJSON(json: any): TravelinePhoneDto {
    return TravelinePhoneDtoFromJSONTyped(json, false);
}

export function TravelinePhoneDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelinePhoneDto {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'remark': json['remark'] == null ? undefined : json['remark'],
    };
}

  export function TravelinePhoneDtoToJSON(json: any): TravelinePhoneDto {
      return TravelinePhoneDtoToJSONTyped(json, false);
  }

  export function TravelinePhoneDtoToJSONTyped(value?: TravelinePhoneDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phoneNumber': value['phoneNumber'],
        'remark': value['remark'],
    };
}

